export default () => {
  const color = "#ADB5BD";
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g clipPath="url(#clip0_6617_49122)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.23096 17.2301C1.23096 29.3926 3.83771 31.9994 16.0002 31.9994C28.1626 31.9994 30.7695 29.3926 30.7695 17.2301C30.7695 5.06762 28.1626 2.46094 16.0002 2.46094C3.83771 2.46094 1.23096 5.06769 1.23096 17.2301ZM3.69252 17.2301C3.69252 20.2146 3.85571 22.4447 4.23121 24.1349C4.60064 25.7969 5.14196 26.7819 5.79521 27.4351C6.44852 28.0884 7.43339 28.6297 9.09552 28.9991C10.7855 29.3747 13.0158 29.5378 16.0002 29.5378C18.9847 29.5378 21.2148 29.3747 22.9048 28.9991C24.567 28.6297 25.5518 28.0884 26.2053 27.4351C26.8585 26.7819 27.3997 25.7969 27.7692 24.1349C28.1447 22.4448 28.3079 20.2146 28.3079 17.2301C28.3079 16.3452 28.2935 15.5265 28.2636 14.7686H3.73683C3.70689 15.5265 3.69252 16.3452 3.69252 17.2301ZM3.91289 12.3071H28.0875C28.006 11.5743 27.9006 10.9168 27.7692 10.3254C27.3997 8.66338 26.8585 7.67844 26.2053 7.02519C25.5518 6.37194 24.567 5.83056 22.9048 5.46119C21.2148 5.08563 18.9847 4.92244 16.0002 4.92244C13.0158 4.92244 10.7855 5.08556 9.09552 5.46119C7.43339 5.83056 6.44852 6.37194 5.79521 7.02519C5.14196 7.67844 4.60064 8.66338 4.23121 10.3254C4.09983 10.9168 3.99439 11.5743 3.91289 12.3071Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
        <path
          d="M7.38477 19.6917C7.38477 19.0119 7.93583 18.4609 8.61552 18.4609H12.3078C12.9876 18.4609 13.5386 19.0119 13.5386 19.6917C13.5386 20.3714 12.9875 20.9224 12.3078 20.9224H8.61552C7.93577 20.9224 7.38477 20.3714 7.38477 19.6917Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
        <path
          d="M7.38477 24.6136C7.38477 23.9338 7.93583 23.3828 8.61552 23.3828H12.3078C12.9876 23.3828 13.5386 23.9338 13.5386 24.6136C13.5386 25.2933 12.9875 25.8443 12.3078 25.8443H8.61552C7.93577 25.8443 7.38477 25.2933 7.38477 24.6136Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
        <path
          d="M23.2404 18.8293C23.721 18.3486 24.5003 18.3486 24.981 18.8293C25.4616 19.3099 25.4616 20.0892 24.981 20.5699L20.0132 25.5375C19.7599 25.7909 19.4235 25.9107 19.0917 25.897C18.7883 25.8885 18.4874 25.7685 18.2559 25.537L16.5153 23.7964C16.0346 23.3157 16.0346 22.5365 16.5153 22.0557C16.996 21.5751 17.7753 21.5751 18.2559 22.0557L19.1348 22.9348L23.2404 18.8293Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
        <path
          d="M11.0769 0C10.3972 0 9.84619 0.551062 9.84619 1.23075V6.15381C9.84619 6.83356 10.3973 7.38456 11.0769 7.38456C11.7566 7.38456 12.3077 6.8335 12.3077 6.15381V1.23075C12.3077 0.551062 11.7566 0 11.0769 0Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
        <path
          d="M20.9231 0C20.2434 0 19.6924 0.551062 19.6924 1.23075V6.15381C19.6924 6.83356 20.2434 7.38456 20.9231 7.38456C21.6029 7.38456 22.1539 6.8335 22.1539 6.15381V1.23075C22.1539 0.551062 21.6029 0 20.9231 0Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_6617_49122">
          <rect width="32" height="32" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
